module.exports = __webpack_public_path__ + "static/media/Before & After.0110588e.png";